const comments = [
  {
    name: '光影旅人',
    time: '2天前',
    content: '蘑菇影院真的是我用过最好的免费电影在线平台！画质清晰还不卡，更新速度超快，流浪地球3上线当天就有高清版了，太给力了。推荐给了周围所有朋友。',
    avatar: 'https://readdy.ai/api/search-image?query=Cinema%20enthusiast%20avatar%20portrait%20in%20warm%20studio%20lighting%2C%20film%20buff%20style%2C%20soft%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '周末影迷',
    time: '5天前',
    content: '作为一个追剧党，蘑菇影院的免费电视剧全集真的太香了。韩剧同步更新，1080P画质在线看完全不缓冲。最重要的是不用注册，即开即看！',
    avatar: 'https://readdy.ai/api/search-image?query=Drama%20fan%20avatar%20portrait%20with%20cozy%20atmosphere%2C%20warm%20natural%20light%2C%20casual%20style%2C%20soft%20blurred%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '深夜刷片人',
    time: '1周前',
    content: '用了大半年了，真心推荐。资源全、画质好、更新快，蘑菇影院的专题合集功能特别实用，按类型找片很方便。纪录片那块简直是宝藏，很多BBC高分纪录片都能看。',
    avatar: 'https://readdy.ai/api/search-image?query=Movie%20lover%20avatar%20portrait%20in%20dim%20warm%20lighting%2C%20thoughtful%20expression%2C%20cinematic%20mood%2C%20soft%20shadows&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              影迷心声
            </h2>
            <p className="text-foreground-500 text-sm">听听使用蘑菇影院的影迷们怎么说</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {comments.map((comment, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl p-6 border border-background-200/60"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <div className="font-semibold text-foreground-900 text-sm">{comment.name}</div>
                    <div className="text-foreground-400 text-xs">{comment.time}</div>
                  </div>
                </div>
                <p className="text-foreground-500 text-xs leading-relaxed">{comment.content}</p>
                <div className="flex items-center gap-3 mt-4 text-accent-400 text-xs">
                  <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 有用</span>
                  <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 回复</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}